import { useQuery } from "react-query"
import { getPaymentsByMeterId } from "../../../meter/services/meterAPI"

export default function useTotalCreditPurchasedCore(deviceId?: string) {
    const query = useQuery({
        queryKey: ['payments', deviceId],
        queryFn: () => getPaymentsByMeterId(deviceId!),
        enabled: !!deviceId,
    })

    const totalKwhPurchased = query.data?.reduce((sum, p) => sum + (p.kwh || 0), 0) ?? 0

    return {
        totalKwhPurchased,
        isLoading: query.isLoading,
        isError: query.isError,
    }
}
